// src/components/forms/GeneralIssuesForm.jsx
import { useNavigate } from 'react-router-dom';
import { LightbulbIcon, HelpIcon, ChevronRightIcon } from './shared/FormIcons';
import styles from '../../styles/forms/SharedForm.module.css';
import Breadcrumb from '../shared/Breadcrumb';
import T, { useTranslate } from '../T';

const FORM_TYPES = [
  {
    id: 'suggestion',
    title: 'Submit a Suggestion',
    description: 'Submit your ideas for business or technical improvements.',
    Icon: LightbulbIcon,
  },
  {
    id: 'question',
    title: 'Ask a Question',
    description: 'Ask operational or system-related questions.',
    Icon: HelpIcon,
  },
];

export default function GeneralIssuesForm() {
  const navigate = useNavigate();
  const { tText } = useTranslate();

  const handleSelect = (id) => {
    navigate(`/staff/request/general/${id}`);
  };

  /* ── Selector ── */
  return (
    <div className={styles.wrapper}>
      <Breadcrumb items={[{ label: tText('General') }]} />
      <div className={styles.heading}>
        <h1 className={styles.title}><T>General</T></h1>
        <p className={styles.sub}>
          <T>Choose the type of general request you'd like to submit.</T>
        </p>
      </div>

      <div className={styles.choices}>
        {FORM_TYPES.map(({ id, title, description, Icon }) => (
          <button
            key={id}
            className={styles.choice}
            onClick={() => handleSelect(id)}
          >
            <div className={styles.choiceIcon}>
              <Icon />
            </div>
            <div className={styles.choiceBody}>
              <p className={styles.choiceTitle}><T>{title}</T></p>
              <p className={styles.choiceDesc}><T>{description}</T></p>
            </div>
            <span className={styles.choiceArrow}>
              <ChevronRightIcon />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
